import { react } from "uikit";

interface Context {
	payType?: string;
	setPayTypeError?: (value: boolean) => void;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const payType = (this.context?.payType || "").trim();
		if (!payType) {
			this.context?.setPayTypeError?.(true);
			return false;
		}
		return true;
	}
}
